import React, { useMemo } from 'react';
import PageViewsView from './page-views-view';
import useURLSearchQuery from '../../../../hooks/use-url-for-search-query';
import { useViews } from './use-page-views';
import { formatDate } from '../audit-utils';
import { ViewsFilters } from '../types';

interface ViewsSearch {
  [key: string]: string | string[];
  entity: string;
  day: string;
  device: string;
}

const defaultSearch: ViewsSearch = {
  entity: '',
  day: formatDate(new Date()),
  device: '',
};

const PageViewsContainer: React.FC = () => {
  const [queryValues, updateURLQuery] = useURLSearchQuery<ViewsSearch>(defaultSearch);

  const { entity, day, device } = queryValues;

  const filters: ViewsFilters = useMemo(() => ({
    entity: entity || undefined,
    day: day || undefined,
    device: device || undefined,
  }), [entity, day, device]);

  const {
    views,
    isLoading,
    error,
    hasMore,
    loadMore,
  } = useViews(filters);

  const handleFilterChange = (name: string, value: unknown) => {
    updateURLQuery({ [name]: String(value ?? '') });
  };

  return (
    <PageViewsView
      views={views}
      isLoading={isLoading}
      error={error}
      hasMore={hasMore}
      loadMore={loadMore}
      filters={queryValues}
      onFilterChange={handleFilterChange}
    />
  );
};

export default PageViewsContainer;
